import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, featureKey } from './ai-function-call.reducer';

// Select the feature state
export const selectAiFunctionCall = createFeatureSelector<State>(featureKey);

// Select data
export const selectAiFunctionCalls = createSelector(
  selectAiFunctionCall,
  (state) => state.data
);

// Select loading state
export const selectAiFunctionCallLoading = createSelector(
  selectAiFunctionCall,
  (state) => state.isLoading
);

// Select loaded state
export const selectAiFunctionCallLoaded = createSelector(
  selectAiFunctionCall,
  (state) => state.loaded
);

// Select error state
export const selectAiFunctionCallError = createSelector(
  selectAiFunctionCall,
  (state) => state.error
);

// Select a single client local state by ID
export const selectAiFunctionCallById = (id: string) =>
  createSelector(selectAiFunctionCalls, (data) =>
    data ? data.find((clientLocalState) => clientLocalState.id === id) : null
  );
